import React, { useState, useEffect, useCallback } from "react";
import { Button } from "antd";
import {
  AppStoreApplication,
  FavoriteType,
  TopType,
  RecommendedType,
  StatusLabels,
  StatusLabelsStyles,
  StatusLabelsText
} from "@/services/AppStore";
// import Rete from '@/components/ThirdApp/components/Rate';
import Bus from "@/utils/bus";
import IconFont, { IconThirdApp } from "@/components/icon";
import { thirdApp } from "@/assets/img/index";
import "./index.less";
import { changeEgovUrl } from "@/utils/tools";
import SvgIcon from "@/baseComponents/SvgIcon";

export default function ToolsItem({
  toolsItem,
  isDragging,
  loading,
  currentApplicationId,
  noAddFav = false,
  onSelected,
  cardLayoutId,
  addFavText = "",
  deleteFavText = "",
  onAdd,
  onDelete
}: {
  toolsItem: AppStoreApplication & { cardLayoutId?: string } & { svg?: string };
  isDragging?: boolean;
  loading: boolean;
  currentApplicationId?: string;
  noAddFav?: boolean;
  onSelected?: Function;
  cardLayoutId?: string;
  addFavText?: string;
  deleteFavText?: string;
  onAdd?: Function;
  onDelete?: Function;
}) {
  const [_loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    if (toolsItem.applicationId === currentApplicationId) {
      setLoading(loading);
    }
  }, [loading, toolsItem, currentApplicationId]);

  // 添加常用
  const AddFavorite = ({
    favoriteType,
    Loading,
    topType,
    addFavText,
    deleteFavText,
    onAdd,
    onDelete,
    disabled
  }: {
    favoriteType: number;
    Loading: boolean;
    topType: TopType;
    addFavText?: string;
    deleteFavText?: string;
    onAdd?: Function;
    onDelete?: Function;
    disabled?: boolean;
  }) => {
    return topType === TopType.TopNo ? (
      <Button
        loading={_loading}
        disabled={_loading || disabled}
        className="tools-favorite-btn"
        style={{
          color: favoriteType === FavoriteType.FavoriteNo ? "#323233" : "#999999",
          cursor: _loading ? "not-allowed" : "pointer"
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (cardLayoutId) {
            toolsItem.emitCallback = () => {
              Bus.emit(`card:refresh:${cardLayoutId}`);
            };
          }
          if (favoriteType === FavoriteType.FavoriteYes) {
            if (onDelete && typeof onDelete === "function") {
              onDelete(toolsItem);
              return;
            }
            Bus.emit("removeFavoriteThirdApp", toolsItem);
          } else {
            if (onAdd && typeof onAdd === "function") {
              onAdd(toolsItem);
              return;
            }
            Bus.emit("onAddFavoriteThirdApp", toolsItem);
          }
        }}
      >
        {favoriteType === FavoriteType.FavoriteNo
          ? addFavText || "添加常用"
          : deleteFavText || "取消常用"}
      </Button>
    ) : (
      <span />
    );
  };
  return (
    <div
      className={isDragging ? "right-tools-tiem right-tools-tiem_bg" : "right-tools-tiem"}
      onClick={() => onSelected && onSelected(toolsItem)}
    >
      <div style={{ display: "flex", flex: 1 }} className="right-item-wrap">
        {/* 工具图标 */}
        <div
          className="right-tools-tiem_logo"
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          {toolsItem.svg ? (
            <SvgIcon
              url={toolsItem.svg}
              className="item-logo-iconfont"
              style={{ width: "24px", height: "24px", backgroundColor: "#ffffff" }}
            />
          ) : toolsItem.icon ? (
            <img src={changeEgovUrl(toolsItem.icon)} alt="" />
          ) : (
            toolsItem.iconfont && (
              <IconFont type={toolsItem.iconfont} className="item-logo-iconfont" />
            )
          )}
        </div>
        {/* 工具名称及简述 */}
        <div className="right-tools-tiem_info">
          <div className="right-tools-tiem_title">
            <span className="main-title">
              <span className="right-tools-tiem_text">{toolsItem.name}</span>
              <div className="main-title-right">
                {toolsItem.recommended === RecommendedType.RecommendedYes && (
                  <span className="right-tools-tiem_lable" style={StatusLabelsStyles.default}>
                    推荐
                  </span>
                )}
                {(toolsItem?.applicationStatusLabels || []).map((key: any, index: number) => {
                  return (
                    <span
                      className="right-tools-tiem_lable"
                      key={index}
                      style={StatusLabelsStyles[key]}
                    >
                      {StatusLabelsText[key]}
                    </span>
                  );
                })}
              </div>
            </span>
            <span className="sub-title">{toolsItem.builder || ""}</span>
            {/* <span style={{ margin: '2px 0 8px -3px' }}>
                            {(toolsItem?.networkEnvLabels || []).map((key: any, index: number) => {
                                if (StatusLabelsText[key] === StatusLabelsText[StatusLabels.VPN]) {
                                    return '';
                                }
                                return (
                                    <span
                                        className="right-tools-tiem_lable right-tools-tiem_lable__boder"
                                        key={index}
                                        style={StatusLabelsStyles[key]}
                                    >
                                        {StatusLabelsText[key]}
                                    </span>
                                );
                            })}
                        </span> */}
            <p className="right-tools-tiem_brief">{toolsItem.brief}</p>
            {/* {toolsItem.builder ? (
                            <p className="right-tools-tiem_developer">
                                建设方：{toolsItem.builder}
                            </p>
                        ) : (
                            <span />
                        )}
                        <p className="right-tools-tiem_developer">开发者：{toolsItem.developer}</p> */}
          </div>
        </div>
      </div>
      {!noAddFav ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* {toolsItem.recommended === RecommendedType.RecommendedNo && ( */}
          <AddFavorite
            favoriteType={toolsItem.favorite}
            Loading={loading}
            topType={toolsItem.topType || TopType.TopNo}
            addFavText={addFavText}
            deleteFavText={deleteFavText}
            onAdd={onAdd}
            onDelete={onDelete}
            disabled={toolsItem.disabled}
          />
          {/* )} */}
        </div>
      ) : null}
    </div>
  );
}
